import React from "react";
import { Input, Select, InputNumber, Table, Switch, Form } from "antd";
import { IndexTagOptions } from "../../views/Indexes/CreateIndexes";

const { Option } = Select;

class TableOne extends React.Component {
  state = {
    tableData: [],
  };

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.targetKeys !== this.props.targetKeys) {
      const result = [];

      this.props.indexesGetData.forEach((e) => {
        if (this.props.targetKeys.includes(e._id) && e.editable) {
          e.custom_values = false;
          if (this.props.initialValue && this.props.initialValue.indexes) {
            const initialIndexesResult = this.props.initialValue.indexes.find(
              (a) => a.index_id._id === e._id && a.custom_values
            );
            if (initialIndexesResult) {
              initialIndexesResult.custom_values_data._id = e._id;
              result.push(initialIndexesResult.custom_values_data);
            } else {
              result.push(e);
            }
          } else {
            result.push(e);
          }
        }
      });
      this.setState({ tableData: result });
    }
  }

  // customValueOnClick = (value, _id) => {
  //   const result = [];
  //   this.state.tableData.forEach((e) => {
  //     if (e._id === _id) {
  //       e.custom_values = value;
  //     }
  //     result.push(e);
  //   });
  //   this.setState({ tableData: result });
  // };

  render() {
    const columns = [
      {
        title: "Name",
        dataIndex: "name",
        key: "name",
        width: "150px",
      },
      {
        title: "Custom Values",
        dataIndex: "custom_values",
        key: "custom_values",
        width: "130px",
        render: (text, record) => (
          <div>
            <div style={{ display: "none" }}>
              <Form.Item
                name={["custom", record._id, "name"]}
                noStyle
                initialValue={record.name}
              >
                <Input />
              </Form.Item>
            </div>
            <div style={{ display: "none" }}>
              <Form.Item
                name={["custom", record._id, "format"]}
                noStyle
                initialValue={record.format}
              >
                <Input />
              </Form.Item>
            </div>
            <Form.Item
              name={["custom", record._id, "custom_values"]}
              noStyle
              valuePropName="checked"
              initialValue={text}
            >

              <Switch />

            </Form.Item>
          </div>
        ),
      },
      {
        title: "Type",
        dataIndex: "type",
        key: "type",
        width: "160px",
        render: (text, record) => (
          <div>
            <Form.Item
              noStyle
              shouldUpdate={(prevValues, currentValues) =>
                prevValues.custom?.[record._id]?.custom_values !==
                currentValues.custom?.[record._id]?.custom_values
              }
            >
              {({ getFieldValue }) => (
                <Form.Item
                  name={["custom", record._id, "type"]}
                  noStyle
                  initialValue={text}
                >

                  <Select disabled={!getFieldValue(["custom", record._id, "custom_values"])}>
                    <Option value={"Boolean"}>Boolean</Option>
                    <Option value={"Date"}>Date</Option>
                    <Option value={"Integer"}>Number</Option>
                    <Option value={"Double"}>Double Number</Option>
                    <Option value={"Text"}>Text</Option>
                    <Option value={"Long"}>Long Text</Option>
                  </Select>

                </Form.Item>
              )}
            </Form.Item>
          </div>
        ),
      },
      {
        title: "Wildcard",
        dataIndex: "wildcard",
        key: "wildcard",
        width: "100px",
        render: (text, record) => (
          <div>
            <Form.Item
              noStyle
              shouldUpdate={(prevValues, currentValues) =>
                prevValues.custom?.[record._id]?.custom_values !==
                currentValues.custom?.[record._id]?.custom_values
              }
            >
              {({ getFieldValue }) => (
                <Form.Item
                  name={["custom", record._id, "wildcard"]}
                  noStyle
                  initialValue={text}
                >
                  <InputNumber disabled={!getFieldValue(["custom", record._id, "custom_values"])} />
                </Form.Item>
              )}
            </Form.Item>
          </div>
        ),
      },
      {
        title: "Order",
        dataIndex: "order",
        key: "order",
        width: "100px",
        render: (text, record) => (
          <div>
            <Form.Item
              noStyle
              shouldUpdate={(prevValues, currentValues) =>
                prevValues.custom?.[record._id]?.custom_values !==
                currentValues.custom?.[record._id]?.custom_values
              }
            >
              {({ getFieldValue }) => (
                <Form.Item
                  name={["custom", record._id, "order"]}
                  noStyle
                  initialValue={text}
                >
                  <InputNumber disabled={!getFieldValue(["custom", record._id, "custom_values"])} />
                </Form.Item>
              )}
            </Form.Item>
          </div>
        ),
      },
      {
        title: "Required",
        dataIndex: "required",
        key: "required",
        width: "100px",
        render: (text, record) => (
          <div>
            <Form.Item
              noStyle
              shouldUpdate={(prevValues, currentValues) =>
                prevValues.custom?.[record._id]?.custom_values !==
                currentValues.custom?.[record._id]?.custom_values
              }
            >
              {({ getFieldValue }) => (
                <Form.Item
                  name={["custom", record._id, "required"]}
                  noStyle
                  initialValue={text}
                >

                  <Select disabled={!getFieldValue(["custom", record._id, "custom_values"])}>
                    <Option value={true}>True</Option>
                    <Option value={false}>False</Option>
                  </Select>

                </Form.Item>
              )}
            </Form.Item>
          </div>
        ),
      },
      {
        title: "Default Index",
        dataIndex: "defaultIndex",
        key: "defaultIndex",
        width: "150px",
        render: (text, record) => (
          <div>
            <Form.Item
              noStyle
              shouldUpdate={(prevValues, currentValues) =>
                prevValues.custom?.[record._id]?.custom_values !==
                currentValues.custom?.[record._id]?.custom_values
              }
            >
              {({ getFieldValue }) => (
                <Form.Item
                  name={["custom", record._id, "defaultIndex"]}
                  noStyle
                  initialValue={text}
                >

                  <Select disabled={!getFieldValue(["custom", record._id, "custom_values"])}>
                    <Option value={true}>True</Option>
                    <Option value={false}>False</Option>
                  </Select>

                </Form.Item>
              )}
            </Form.Item>
          </div>
        ),
      },
      {
        title: "Available In IS",
        dataIndex: "availableInIS",
        key: "availableInIS",
        width: "150px",
        render: (text, record) => (
          <div>
            <Form.Item
              noStyle
              shouldUpdate={(prevValues, currentValues) =>
                prevValues.custom?.[record._id]?.custom_values !==
                currentValues.custom?.[record._id]?.custom_values
              }
            >
              {({ getFieldValue }) => (
                <Form.Item
                  name={["custom", record._id, "availableInIS"]}
                  noStyle
                  initialValue={text}
                >

                  <Select disabled={!getFieldValue(["custom", record._id, "custom_values"])}>
                    <Option value={true}>True</Option>
                    <Option value={false}>False</Option>
                  </Select>

                </Form.Item>
              )}
            </Form.Item>
          </div>
        ),
      },
      {
        title: "Tags",
        dataIndex: "tags",
        key: "tags",
        width: "150px",
        render: (text, record) => (
          <div>
            <Form.Item
              noStyle
              shouldUpdate={(prevValues, currentValues) =>
                prevValues.custom?.[record._id]?.custom_values !==
                currentValues.custom?.[record._id]?.custom_values
              }
            >
              {({ getFieldValue }) => (
                <Form.Item
                  name={["custom", record._id, "tags"]}
                  noStyle
                  initialValue={text}
                >
                  <Select
                    disabled={!getFieldValue(["custom", record._id, "custom_values"])}
                    mode="tags"
                    showArrow
                    style={{ width: "100%" }}
                    options={IndexTagOptions}
                  />
                </Form.Item>
              )}
            </Form.Item>
          </div>
        ),
      },
      {
        title: "Value Type",
        dataIndex: "value_type",
        key: "value_type",
        width: "150px",
        render: (text, record) => (
          <div>
            <Form.Item
              noStyle
              shouldUpdate={(prevValues, currentValues) =>
                prevValues.custom !==
                currentValues.custom
              }
            >
              {({ getFieldValue }) => {
                const disableValueType = [];
                const valueTypeValue = getFieldValue("custom");
                if (valueTypeValue) {
                  for (const [k, a] of Object.entries(valueTypeValue)) {
                    if (a && a.value_type) {
                      if (
                        a.name === "Hotels" &&
                        !a.custom_values
                      ) {
                        disableValueType.push("Hotels");
                      }
                      if (
                        a.name === "Report Category" &&
                        !a.custom_values
                      ) {
                        disableValueType.push("Report Category");
                      }
                      if (
                        a.name === "Report Name" &&
                        !a.custom_values
                      ) {
                        disableValueType.push("Report");
                      }
                      if (
                        a.name === "Submission Schedule" &&
                        !a.custom_values
                      ) {
                        disableValueType.push("Submission Schedule");
                      }
                      disableValueType.push(a.value_type);
                    }
                  }
                }
                return (
                  <Form.Item
                    name={["custom", record._id, "value_type"]}
                    noStyle
                    initialValue={text}
                  >
                    <Select disabled={!getFieldValue(["custom", record._id, "custom_values"])}>
                      <Option value="None">None</Option>
                      <Option value="Custom">Custom</Option>
                      <Option
                        value="Hotels"
                        disabled={disableValueType.includes("Hotels")}
                      >
                        Hotels
                      </Option>
                      <Option
                        value="Report"
                        disabled={disableValueType.includes("Report")}
                      >
                        Report
                      </Option>
                      <Option
                        value="Report Category"
                        disabled={disableValueType.includes("Report Category")}
                      >
                        Report Category
                      </Option>
                      <Option
                        value="Submission Schedule"
                        disabled={disableValueType.includes("Submission Schedule")}
                      >
                        Submission Schedule
                      </Option>
                    </Select>

                  </Form.Item>
                )
              }}
            </Form.Item>
          </div>
        ),
      },
      {
        title: "Values",
        dataIndex: "values",
        key: "values",
        // width: "200px",
        render: (text, record) => (
          <div>
            <Form.Item
              noStyle
              shouldUpdate={(prevValues, currentValues) =>
                prevValues.custom?.[record._id]?.value_type !==
                currentValues.custom?.[record._id]?.value_type || prevValues.custom?.[record._id]?.custom_values !==
                currentValues.custom?.[record._id]?.custom_values
              }
            >
              {({ getFieldValue }) => (
                <Form.Item
                  name={["custom", record._id, "values"]}
                  noStyle
                  initialValue={text}
                >
                  <Select
                    // showSearch
                    //   optionFilterProp="children"
                    className="is_min_width_increase"
                    mode="tags"
                    notFoundContent={null}
                    disabled={
                      !getFieldValue(["custom", record._id, "custom_values"]) ||
                      getFieldValue(["custom", record._id, "value_type"]) !==
                      "Custom"
                    }
                  ></Select>
                </Form.Item>
              )}
            </Form.Item>
          </div>
        ),
      },
    ];
    return (
      <div>
        {this.state.tableData.length > 0 ? (
          <Table
            dataSource={this.state.tableData}
            columns={columns}
            pagination={false}
            scroll={{ x: 1500 }}
            rowKey="_id"
            size="small"
          />
        ) : null}
      </div>
    );
  }
}

export default TableOne;
